// extracted by mini-css-extract-plugin
export default {"tags_container":"tags_tags_container__pyZ02","tags_list":"tags_tags_list__r66CS","tag":"tags_tag__7m6YX","night":"tags_night__lfsFY"};